import styled from 'styled-components';
import bannerBackground from '../../assets/images/banner_background.png';

const BREAKPOINT = 768;   // 태블릿 이상
const LG = 1200;          // 큰 데스크탑

const MainBannerContainer = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 200px;
    height: 30vw;                /* 모바일: 화면 비율에 맞춰 유동 */
    max-height: 520px;
    background: linear-gradient(180deg, #e7f8ff 0%, #cdf3ff 100%);
    overflow: hidden;

    /* 은은한 그리드/노이즈 느낌 */
    &:after{
        content:'';
        position:absolute; inset:0;
        background-image: radial-gradient(rgba(255,255,255,.35) 1px, transparent 1px);
        background-size: 18px 18px;
        opacity:.4; pointer-events:none;
    }

    @media (min-width: ${BREAKPOINT}px) {
        height: 200px;
        max-height: none;
    }

    @media (min-width: ${LG}px) {
        height: 200px;
    }
`;

const Description = styled.div`
    position: relative;
    z-index: 1;
    max-width: 1280px;
    width: 100%;
    /* 모바일: 가운데 배치 */
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: center;
    justify-content: center;

    /* 태블릿 이상: 좌측 정렬 */
    @media (min-width: ${BREAKPOINT}px) {
        text-align: left;
        align-items: flex-start;
    }
    

    h1{
        font-size: clamp(28px, 6vw, 44px);
        line-height: 1.2;
        font-weight: 800;
        letter-spacing: -0.02em;
    }

    h2{
        color: #0f172a;
        opacity: .85;
        font-weight: 600;
        font-size: clamp(14px, 3.6vw, 18px);
        line-height: 1.6;
    }
`;

const RedText = styled.span`
  color: #ff2828;
`;

const BackgroundImageWrap = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center flex-end;
  pointer-events: none;
`;

/* 우측 일러스트 */
const BackgroundImage = styled.img`
  position: relative;
  right: -12px;
  top: 90px;
  width: min(50vw, 420px);    /* 모바일: 화면 비율 기반 */
  height: auto;
  object-fit: contain;
  transform: translateY(0);
  filter: drop-shadow(0 18px 30px rgba(15,23,42,.12));

  /* 태블릿 이상: 조금 더 크게 + 우측 정렬 */
  @media (min-width: ${BREAKPOINT}px) {
    right: 24px;
    width: 460px;
  }

  @media (min-width: ${LG}px) {
    right: 40px;
    width: 560px;
  }
`;

function MainBanner() {
    return (
        <MainBannerContainer>
            <Description>
                <h1>
                    <RedText>디지털알리미</RedText> 울동네
                </h1>
                <h2>
                    디지털시대에 발맞춘
                    <br />
                    지역상인들과 개업공인중개사를 위한
                    <br />
                    디지털 광고 플랫폼
                </h2>
            </Description>

            <BackgroundImageWrap aria-hidden>
                <BackgroundImage src={bannerBackground} alt="" draggable={false} />
            </BackgroundImageWrap>
        </MainBannerContainer>
    );
}

export default MainBanner;
